<template>
  <component
    :is="componentType"
    :to="to"
    :data-section-selector="selector"
    :class="{'scrollactive-item': scrollactiveItem, 'dropdown-item': dropdownItem, 'nav-link': !dropdownItem}"
    @click.native.stop="closeNav"
  >
    <slot></slot>
  </component>
</template>
<script>
export default {
  name: 'nav-link',
  inject: ['closeNavbar'],
  props: {
    to: {
      type: [String, Object],
      default: undefined
    },
    scrollactiveItem: Boolean,
    dropdownItem: Boolean,
    selector: String,
  },
  computed: {
    componentType() {
      return this.to ? 'router-link' : 'a';
    }
  },
  methods: {
    closeNav() {
      if (this.closeNavbar) {
        this.closeNavbar();
      }
    }
  }
};
</script>
<style></style>
